<div mat-dialog-title>
  <h2>{{ data.title }}</h2>
</div>
<div mat-dialog-content>
  <p [innerHTML]="data.confirmText"></p>
</div>
<div mat-dialog-actions>
  <button mat-stroked-button (click)="onCancel()">Cancel</button>
  @if (data.confirmBtn) {
    <button mat-flat-button [color]="data.color" [mat-dialog-close]="true" cdkFocusInitial>{{ data.confirmBtn }}</button>
  }
</div>
